import { useCallback } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { appPath } from '../constants/appBasePath';

export function useAppLogout() {
  const { logout } = useAuth0();

  return useCallback(() => {
    logout({
      logoutParams: { returnTo: window.location.origin + appPath('/signup') },
    });
  }, [logout]);
}
